export default __webpack_public_path__ + "static/media/id-flash-back.b001027d.jpg";